import type { GraphData, GraphLink, GraphNode } from "../types/graph";

function linkKey(link: GraphLink): string {
  return `${link.source}→${link.target}→${link.type}`;
}

export function dedupeGraphNodes(nodes: GraphNode[]): GraphNode[] {
  const seen = new Set<string>();
  return nodes.filter((node) => {
    if (seen.has(node.id)) return false;
    seen.add(node.id);
    return true;
  });
}

export function dedupeGraphLinks(links: GraphLink[]): GraphLink[] {
  const seen = new Set<string>();
  return links.filter((link) => {
    const key = linkKey(link);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function mergeGraphData(
  prev: GraphData,
  newNodes: GraphNode[],
  newLinks: GraphLink[],
): GraphData {
  const existingNodeIds = new Set(prev.nodes.map((node) => node.id));
  const existingLinkKeys = new Set(prev.links.map(linkKey));
  const dedupedNodes = dedupeGraphNodes(newNodes).filter(
    (node) => !existingNodeIds.has(node.id),
  );
  const dedupedLinks = dedupeGraphLinks(newLinks).filter(
    (link) => !existingLinkKeys.has(linkKey(link)),
  );

  return {
    nodes: [...prev.nodes, ...dedupedNodes],
    links: [...prev.links, ...dedupedLinks],
  };
}

export function normalizeAreaLabel(value: string | null | undefined): string | null {
  const normalized = value?.trim();
  return normalized ? normalized : null;
}